import { FC, useEffect } from 'react';
import { connect } from 'react-redux';

import { LoaderContainer } from '~src/shared/sidebar/styles/sidebar.sc';
import PageLoader from '~src/shared/pageLoader/PageLoader';
import { logout } from '~src/store/session/actions';

interface DispatchProps {
  doLogout(): void;
}

interface OwnProps {
  isAuthenticated: boolean;
}

type Props = OwnProps & DispatchProps;

const Logout: FC<Props> = ({ doLogout, isAuthenticated }) => {
  useEffect(() => {
    if (isAuthenticated) {
      doLogout();
    }
  }, []);

  return (
    <LoaderContainer>
      <PageLoader />
    </LoaderContainer>
  );
};

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  doLogout: () => dispatch(logout),
});

const LogoutC = connect(null, mapDispatchToProps)(Logout);

export default LogoutC;
